/* ELARVÉE — Blue Ritual theme scripts (vanilla JS) */
(function () {
  'use strict';

  var E = window.Elarvee || {};
  var routes = E.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartJs: '/cart.js' };

  /* ---------------- Utilities ---------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || E.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  E.formatMoney = formatMoney;

  function lockScroll(on) { document.body.classList.toggle('no-scroll', !!on); }

  /* ---------------- Checkout routing (discount code) ---------------- */
  function checkoutUrl() {
    var d = E.discount || {};
    if (d.enabled && d.code) {
      return routes.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(d.code) + '?redirect=' + encodeURIComponent('/checkout');
    }
    return routes.root.replace(/\/$/, '') + '/checkout';
  }
  E.goToCheckout = function () { window.location.href = checkoutUrl(); };

  /* ---------------- Cart API ---------------- */
  var Cart = {
    get: function () {
      return fetch(routes.cartJs, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
    },
    add: function (items) {
      return fetch(routes.cartAdd, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) { var err = new Error(data.description || data.message || 'Could not add to cart'); err.data = data; throw err; }
          return data;
        });
      });
    },
    change: function (key, quantity) {
      return fetch(routes.cartChange, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) { var err = new Error(data.description || data.message || 'Could not update cart'); throw err; }
          return data;
        });
      });
    }
  };
  E.cart = Cart;

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer = null;
  var lastFocus = null;

  function imgUrl(src, width) {
    if (!src) return '';
    try {
      var u = new URL(src, window.location.origin);
      if (/cdn\.shopify|\/cdn\/shop\//.test(u.href)) u.searchParams.set('width', width);
      return u.href;
    } catch (e) { return src; }
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = $('[data-cart-body]', drawer);
    var foot = $('[data-cart-foot]', drawer);
    var countEl = $('[data-cart-drawer-count]', drawer);
    var offer = $('[data-cart-offer]', drawer);
    if (countEl) countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    updateCount(cart.item_count);

    if (!cart.item_count) {
      body.innerHTML = $('[data-cart-empty-template]', drawer).innerHTML;
      foot.hidden = true;
      if (offer) offer.hidden = true;
      document.dispatchEvent(new CustomEvent('elarvee:cart', { detail: cart }));
      return;
    }
    if (offer) offer.hidden = false;
    foot.hidden = false;
    var html = cart.items.map(function (item, i) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      var compare = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
      var discounts = (item.line_level_discount_allocations || []).map(function (d) {
        return '<div class="cart-item__discount">' + escapeHtml(d.discount_application ? d.discount_application.title : '') + ' (−' + formatMoney(d.amount) + ')</div>';
      }).join('');
      var img = item.image ? '<img src="' + escapeHtml(imgUrl(item.image, 200)) + '" alt="' + escapeHtml(item.product_title) + '" width="78" height="92" loading="lazy">' : '';
      return '<div class="cart-item" data-line="' + (i + 1) + '" data-key="' + escapeHtml(item.key) + '">' +
        '<a class="cart-item__img" href="' + escapeHtml(item.url) + '">' + img + '</a>' +
        '<div><a class="cart-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant + discounts +
        '<div class="cart-item__price">' + compare + formatMoney(item.final_line_price) + '</div>' +
        '<div class="cart-item__controls">' +
          '<div class="qty"><button type="button" data-qty-change="-1" aria-label="Decrease quantity"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
          '<input type="number" min="0" value="' + item.quantity + '" aria-label="Quantity" data-qty-input>' +
          '<button type="button" data-qty-change="1" aria-label="Increase quantity"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button></div>' +
          '<button type="button" class="cart-item__remove" data-remove aria-label="Remove ' + escapeHtml(item.product_title) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>Remove</button>' +
        '</div></div>' +
      '</div>';
    }).join('');
    body.innerHTML = html;
    var subtotal = $('[data-cart-subtotal]', drawer);
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    document.dispatchEvent(new CustomEvent('elarvee:cart', { detail: cart }));
  }
  E.renderCart = function (cart) { renderDrawer(cart); };

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var close = $('[data-cart-close]', drawer);
    if (close) setTimeout(function () { close.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  E.changeCartLine = function (key, qty) { return changeLine(key, qty); };
  E.openCart = function () { Cart.get().then(function (c) { renderDrawer(c); openDrawer(); }); };

  function changeLine(key, qty) {
    drawer.classList.add('is-busy');
    return Cart.change(key, qty).then(function (cart) { renderDrawer(cart); })
      .catch(function (e) { alert(e.message); return Cart.get().then(renderDrawer); })
      .finally(function () { drawer.classList.remove('is-busy'); });
  }

  function initDrawer() {
    drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
      if (t.closest('[data-checkout]')) { e.preventDefault(); E.goToCheckout(); return; }
      var row = t.closest('.cart-item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var input = $('[data-qty-input]', row);
      var btn = t.closest('[data-qty-change]');
      if (btn) {
        var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-change'), 10));
        changeLine(key, q);
      } else if (t.closest('[data-remove]')) {
        changeLine(key, 0);
      }
    });
    drawer.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var row = e.target.closest('.cart-item');
      changeLine(row.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ---------------- Add to cart (delegated) ---------------- */
  function afterAdd() {
    if (E.cartType === 'page') { window.location.href = routes.cart; return Promise.resolve(); }
    return Cart.get().then(function (cart) { renderDrawer(cart); openDrawer(); });
  }

  function addFromButton(btn) {
    var id = btn.getAttribute('data-variant-id');
    var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
    if (!id) { window.location.href = btn.getAttribute('data-fallback-url') || routes.root; return; }
    btn.classList.add('is-loading');
    Cart.add([{ id: parseInt(id, 10), quantity: qty }])
      .then(function () {
        if (btn.hasAttribute('data-buy-now')) { E.goToCheckout(); return; }
        return afterAdd();
      })
      .catch(function (e) { alert(e.message); })
      .finally(function () { btn.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (btn) { e.preventDefault(); addFromButton(btn); return; }
    var open = e.target.closest('[data-open-cart]');
    if (open && drawer && E.cartType !== 'page') { e.preventDefault(); E.openCart(); return; }
    var checkout = e.target.closest('[data-checkout]');
    if (checkout && !checkout.closest('[data-cart-drawer]')) {
      // cart page: submit form updates first then go to checkout
      var form = checkout.closest('form');
      if (form && form.hasAttribute('data-cart-form')) {
        e.preventDefault();
        var fd = new FormData(form);
        fetch(routes.cart.replace(/\/$/, '') + '/update.js', { method: 'POST', body: fd, credentials: 'same-origin' })
          .finally(function () { E.goToCheckout(); });
      } else { e.preventDefault(); E.goToCheckout(); }
    }
  });

  /* ---------------- Product form ---------------- */
  function initProductForm(root) {
    $$('[data-product-form]', root).forEach(function (form) {
      if (form.__init) return; form.__init = true;
      var section = form.closest('[data-product-section]') || document;
      var qtyInput = $('[name="quantity"]', form);
      var idInput = $('[name="id"]', form);
      var msg = $('[data-product-msg]', section);
      var priceEl = $('[data-product-price]', section);
      var stickyPrice = $('[data-sticky-price]', section);

      function setSelected(opt) {
        $$('.bundle-opt', section).forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
      }
      $$('[data-bundle-radio]', section).forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          qtyInput.value = radio.getAttribute('data-qty');
          setSelected(radio.closest('.bundle-opt'));
          var label = radio.getAttribute('data-price-label');
          if (stickyPrice && label) stickyPrice.textContent = label;
        });
      });
      qtyInput && qtyInput.addEventListener('change', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v < 1) { v = 1; qtyInput.value = 1; }
        var match = null;
        $$('[data-bundle-radio]', section).forEach(function (r) {
          var m = parseInt(r.getAttribute('data-qty'), 10) === v; r.checked = m; if (m) match = r;
        });
        setSelected(match ? match.closest('.bundle-opt') : null);
      });

      var variantSelect = $('[data-variant-select]', section);
      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          var o = variantSelect.options[variantSelect.selectedIndex];
          idInput.value = variantSelect.value;
          if (priceEl && o.getAttribute('data-price')) priceEl.textContent = o.getAttribute('data-price');
          $$('[data-variant-id]', section).forEach(function (b) { b.setAttribute('data-variant-id', variantSelect.value); });
          var atc = $('[data-submit]', form);
          var available = o.getAttribute('data-available') === 'true';
          if (atc) { atc.disabled = !available; atc.querySelector('span').textContent = available ? atc.getAttribute('data-label') : atc.getAttribute('data-soldout'); }
          var url = new URL(window.location.href); url.searchParams.set('variant', variantSelect.value);
          window.history.replaceState({}, '', url.toString());
        });
      }

      function submit(buyNow, trigger) {
        if (msg) msg.textContent = '';
        var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
        trigger.classList.add('is-loading');
        Cart.add([{ id: parseInt(idInput.value, 10), quantity: qty }])
          .then(function () { return buyNow ? E.goToCheckout() : afterAdd(); })
          .catch(function (e) { if (msg) msg.textContent = e.message; else alert(e.message); })
          .finally(function () { trigger.classList.remove('is-loading'); });
      }
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(false, $('[data-submit]', form)); });
      $$('[data-buy-now-form]', section).forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); submit(true, b); });
      });
      $$('[data-sticky-submit]', section).forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); submit(false, b); });
      });

      // quantity steppers
      $$('[data-step]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
          qtyInput.value = v; qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // sticky add to cart
      var sticky = $('[data-sticky-atc]', section);
      var anchor = $('[data-submit]', form);
      if (sticky && anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
        }).observe(anchor);
      }
    });
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery(root) {
    $$('[data-gallery]', root).forEach(function (g) {
      if (g.__init) return; g.__init = true;
      var slides = $$('.gallery__main > img', g);
      var thumbs = $$('[data-gallery-thumb]', g);
      function show(i) {
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var x0 = null;
      var main = $('.gallery__main', g);
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 == null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) < 40) return;
          var cur = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
          show((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
        });
      }
    });
  }

  /* ---------------- Ingredient tabs ---------------- */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (wrap) {
      if (wrap.__init) return; wrap.__init = true;
      var tabs = $$('[role="tab"]', wrap);
      function activate(tab, focus) {
        var id = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        $$('[data-tab-panel]', wrap).forEach(function (p) {
          var on = p.getAttribute('data-tab-panel') === id;
          p.classList.toggle('is-active', on);
          p.classList.toggle('is-switched', on);
          p.hidden = !on;
        });
        $$('[data-tab-image]', wrap).forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-tab-image') === id);
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); activate(n, true); }
        });
      });
    });
    // mobile ingredient rows
    $$('[data-ing-toggle]', root).forEach(function (b) {
      if (b.__init) return; b.__init = true;
      b.addEventListener('click', function () {
        var row = b.closest('.ing-row');
        var open = row.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------- Accordions ---------------- */
  function initAccordions(root) {
    $$('[data-accordion]', root).forEach(function (acc) {
      if (acc.__init) return; acc.__init = true;
      var single = acc.hasAttribute('data-single');
      $$('.acc-item__q', acc).forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.acc-item');
          var open = !item.classList.contains('is-open');
          if (single && open) {
            $$('.acc-item.is-open', acc).forEach(function (o) {
              if (o !== item) { o.classList.remove('is-open'); $('.acc-item__q', o).setAttribute('aria-expanded', 'false'); }
            });
          }
          item.classList.toggle('is-open', open);
          q.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------------- Carousels ---------------- */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (c) {
      if (c.__init) return; c.__init = true;
      var track = $('[data-carousel-track]', c);
      if (!track) return;
      var dotsWrap = $('[data-carousel-dots]', c);
      function step() {
        var item = track.children[0];
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      $$('[data-carousel-prev]', c).forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
      $$('[data-carousel-next]', c).forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
      if (dotsWrap) {
        var n = track.children.length;
        dotsWrap.innerHTML = '';
        for (var i = 0; i < n; i++) {
          (function (i) {
            var d = document.createElement('button');
            d.type = 'button'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            d.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
            dotsWrap.appendChild(d);
          })(i);
        }
        var update = function () {
          var idx = Math.round(track.scrollLeft / Math.max(1, step()));
          $$('button', dotsWrap).forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        };
        track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
        update();
      }
    });
  }

  /* ---------------- Bundle cards (homepage) ---------------- */
  function initBundleCards(root) {
    $$('[data-bundle-grid]', root).forEach(function (grid) {
      if (grid.__init) return; grid.__init = true;
      grid.addEventListener('click', function (e) {
        var card = e.target.closest('.bundle-card');
        if (!card || e.target.closest('[data-add-to-cart]')) {
          if (card) select(card);
          return;
        }
        select(card);
      });
      function select(card) {
        $$('.bundle-card', grid).forEach(function (c) {
          var on = c === card;
          c.classList.toggle('is-selected', on);
          var r = $('.bundle-card__radio', c); if (r) r.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
    });
  }

  /* ---------------- Header: menu, search, scroll ---------------- */
  function initHeader(root) {
    var header = $('[data-header]', root);
    if (header && !header.__init) {
      header.__init = true;
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    var menu = $('[data-mobile-menu]', root);
    if (menu && !menu.__init) {
      menu.__init = true;
      $$('[data-menu-open]', root).forEach(function (b) {
        b.addEventListener('click', function () { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); b.setAttribute('aria-expanded', 'true'); lockScroll(true); });
      });
      $$('[data-menu-close]', menu).forEach(function (b) {
        b.addEventListener('click', function () {
          menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); lockScroll(false);
          $$('[data-menu-open]', root).forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
        });
      });
      $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { menu.classList.remove('is-open'); lockScroll(false); }); });
    }
    $$('[data-search-toggle]', root).forEach(function (b) {
      if (b.__init) return; b.__init = true;
      b.addEventListener('click', function (e) {
        var panel = $('[data-search-panel]');
        if (!panel) return;
        e.preventDefault();
        panel.hidden = !panel.hidden;
        b.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
        if (!panel.hidden) { var i = $('input', panel); if (i) i.focus(); }
      });
    });
  }

  /* ---------------- Video ---------------- */
  function initVideo(root) {
    $$('[data-video]', root).forEach(function (v) {
      if (v.__init) return; v.__init = true;
      var btn = $('[data-video-play]', v);
      var tpl = $('template', v);
      if (!btn || !tpl) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var media = $('.video-card__media', v);
        media.appendChild(tpl.content.cloneNode(true));
        btn.remove();
        var vid = $('video', media); if (vid) vid.play();
      });
    });
  }

  /* ---------------- Newsletter success scroll ---------------- */

  function initAll(root) {
    root = root || document;
    initHeader(root); initTabs(root); initAccordions(root); initCarousels(root);
    initBundleCards(root); initProductForm(root); initGallery(root); initVideo(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initAll(document);
    Cart.get().then(function (c) { updateCount(c.item_count); }).catch(function () {});
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); if (!drawer) initDrawer(); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.matches('[role="tab"]') ? e.target : null;
    var panel = e.target.closest ? e.target.closest('[data-tab-panel]') : null;
    if (panel) {
      var t = document.querySelector('[role="tab"][data-tab="' + panel.getAttribute('data-tab-panel') + '"]');
      if (t) t.click();
    } else if (tab) tab.click();
    var acc = e.target.closest ? e.target.closest('.acc-item') : null;
    if (acc && !acc.classList.contains('is-open')) { var q = acc.querySelector('.acc-item__q'); if (q) q.click(); }
  });
})();
